import * as Yup from "yup";

export function schema(fields) {
  var validationSchema = Yup.object().shape({
    channel_id: Yup.string().required("Channel is required"),
  });

  for (let field of fields) {
    if (field.control_id === 1 && field.is_mandatory) {
      validationSchema = validationSchema.concat(
        Yup.object({
          [field.name]: Yup.string().required(field.label + " is required"),
        })
      );
    }
  }

  return validationSchema;
}

export const logo = {
  SMS: "https://dolphinchat-chat.s3.ap-south-1.amazonaws.com/publicURLS/a2d75083a653441c8541c4de8c0e3088/1747042821280_Messaging.png",
  Facebook:
    "https://dolphinchat-chat.s3.ap-south-1.amazonaws.com/publicURLS/a2d75083a653441c8541c4de8c0e3088/1747042840971_Facebook%20%281%29.png",
  Whatsapp:
    "https://dolphinchat-chat.s3.ap-south-1.amazonaws.com/publicURLS/a2d75083a653441c8541c4de8c0e3088/1747042855409_WhatsApp.png",
  "Google Ads":
    "https://dolphinchat-chat.s3.ap-south-1.amazonaws.com/publicURLS/a2d75083a653441c8541c4de8c0e3088/1747042874370_google.png",
};
